// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\r\n    spinner.overlay.component\r\n*/\r\n:host {\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  position: fixed;\r\n  z-index: 9999;\r\n}\r\n:host(.spinner-overlay-default) {\r\n  background-color: rgba(0, 0, 0, 0.25);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
